<template>
    <div class="post-share">
    	<div class="post-share-title">
    		Share
    	</div>
    	<div class="post-share-wrap">
    		<div class="post-share-single">
	    		<button class="item">
	    			<svg width="43" height="50" xmlns="http://www.w3.org/2000/svg"><path d="M4.526 0h27.158v4.545H4.526v31.819H0V4.545C0 2.045 2.037 0 4.526 0zm33.948 9.09H13.579c-2.49 0-4.526 2.046-4.526 4.546v31.819c0 2.5 2.036 4.545 4.526 4.545h24.895C40.964 50 43 47.955 43 45.455V13.636c0-2.5-2.037-4.545-4.526-4.545zM13.579 45.455h24.895V13.637H13.579v31.819z" fill="#636B73" fill-rule="evenodd"/></svg>
	    		</button>
	    		<p>Copy link</p>
	    	</div>
    		<div class="post-share-single">
	    		<button class="item">
					<svg width="24" height="49" xmlns="http://www.w3.org/2000/svg"><path d="M23.43 15.739h-7.645v-5.014c0-1.883 1.248-2.322 2.127-2.322h5.395V.125l-7.43-.029C7.629.096 5.752 6.27 5.752 10.221v5.518H.982v8.53h4.77v24.137h10.033V24.269h6.77l.875-8.53z" fill="#3A589B"/></svg>
	    		</button>
	    		<p>Facebook</p>
	    	</div>
    		<div class="post-share-single">
	    		<button class="item">
					<svg width="59" height="47" xmlns="http://www.w3.org/2000/svg"><path d="M52.397 13.147c0-.51-.01-1.018-.033-1.523a24.142 24.142 0 005.97-6.1 24.17 24.17 0 01-6.873 1.855c2.47-1.46 4.368-3.766 5.262-6.516a24.241 24.241 0 01-7.6 2.859A12.043 12.043 0 0040.388 0C33.778 0 28.42 5.276 28.42 11.78c0 .924.105 1.823.31 2.686-9.947-.493-18.767-5.18-24.67-12.31a11.612 11.612 0 00-1.62 5.922c0 4.087 2.113 7.696 5.326 9.806a12.021 12.021 0 01-5.42-1.473c-.002.05-.002.098-.002.15 0 5.706 4.125 10.47 9.602 11.55a12.185 12.185 0 01-5.406.201c1.524 4.681 5.942 8.087 11.18 8.183-4.096 3.16-9.256 5.043-14.864 5.043-.965 0-1.918-.055-2.855-.163a34.272 34.272 0 0018.346 5.292c22.013 0 34.051-17.953 34.051-33.52z" fill="#1DA1F2"/></svg>
	    		</button>
	    		<p>Twitter</p>
	    	</div>
    		<div class="post-share-single">
	    		<button class="item">
					<svg width="56" height="45" xmlns="http://www.w3.org/2000/svg"><path d="M5.6 0h44.8C53.48 0 56 2.531 56 5.625v33.75C56 42.469 53.48 45 50.4 45H5.6C2.52 45 0 42.469 0 39.375V5.625C0 2.531 2.52 0 5.6 0zM28 25.313L50.4 11.25V5.625L28 19.688 5.6 5.624v5.625L28 25.313z" fill="#636B73" fill-rule="evenodd"/></svg>
	    		</button>
	    		<p>Email</p>
	    	</div>
    		<div class="post-share-single">
	    		<button class="item">
					<svg width="29" height="52" xmlns="http://www.w3.org/2000/svg"><path d="M26.29 42.208c-1.37.585-2.851.87-4.342.836a4.61 4.61 0 01-4.611-4.61V21.667H27.45v-7.223H17.337V0h-7.224A13.528 13.528 0 010 14.444v7.223h5.779l.062 15.958A14.933 14.933 0 0029 49.521l-2.71-7.313z" fill="#2C4762"/></svg>
	    		</button>
	    		<p>Tumblr</p>
	    	</div>
    		<div class="post-share-single">
	    		<button class="item">
					<svg width="66" height="41" xmlns="http://www.w3.org/2000/svg"><path d="M9.69 20.5l15.47 15.717L20.4 41 0 20.5 20.4 0l4.93 4.783L9.69 20.5zm48.79 0L42.84 36.217 47.6 41 68 20.5 47.6 0l-4.76 4.783L58.48 20.5z" fill="#636B73" fill-rule="evenodd"/></svg>
	    		</button>
	    		<p>Embed</p>
	    	</div>
    	</div>
    	<slot name="close">
	    	<div class="cancel-share">
		    	<button @click="cancel">Cancel</button>
		    </div>
		</slot>
    </div>
</template>


<script>
	import { EventBus } from '../../../main';
	export default {
      	name: "post-share",

		data(){
			return {

	      	}
	    },


	    methods: {
	    	cancel(){
    			EventBus.$emit('shareCancel',false);
	    	}


	    },

	    created() {

	    }

    }

</script>
